'use strict';
var parent = require('../../actual/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/slice.js
// module id = 626
// module chunks = 13